var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"reaction-button space-children-inline-tight",class:{
		'default-border': _vm.displayDefaultBorder,
		'has-reacted': _vm.hasCurrentUserReacted,
		'button-regular': _vm.size === _vm.Size.MEDIUM,
		'button-small': _vm.size === _vm.Size.SMALL
	}},[_c('span',[_vm._v(" "+_vm._s(_vm.icon)+" ")]),(_vm.displayCount)?_c('span',{staticClass:"text-medium"},[_vm._v(" "+_vm._s(_vm.count)+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }